import { logger } from '@/utils/logger'

const log = logger.module('dripCampaign')

export interface DripEmail {
  id: string
  dayOffset: number
  subject: string
  preheader: string
  templateKey: string
}

export interface DripCampaignConfig {
  name: string
  description: string
  triggerAfterHours: number
  emails: DripEmail[]
}

export interface CompanyInfo {
  name: string
  ownerName: string
  email: string
  phone: string
  website: string
  tagline: string
}

export const DRIP_CAMPAIGN: DripCampaignConfig = {
  name: 'Lead Re-engagement',
  description: 'Nurture leads back into the funnel with educational content',
  triggerAfterHours: 48,
  emails: [
    {
      id: 'drip_1_safety',
      dayOffset: 3,
      subject: "What IKEA won't tell you about bunk beds",
      preheader: "The hidden danger in mass-produced furniture",
      templateKey: 'safety_quality'
    },
    {
      id: 'drip_2_social_proof',
      dayOffset: 5,
      subject: "How the Hendersons transformed their vacation rental",
      preheader: "From 4 guests to 12 – and 40% more income",
      templateKey: 'social_proof'
    },
    {
      id: 'drip_3_objection',
      dayOffset: 8,
      subject: "Is a custom bunk bed really worth it?",
      preheader: "Let's break down the real math",
      templateKey: 'objection_handler'
    },
    {
      id: 'drip_4_scarcity',
      dayOffset: 12,
      subject: "Our build calendar is filling up",
      preheader: "Just a heads up before the rush",
      templateKey: 'scarcity'
    },
    {
      id: 'drip_5_value',
      dayOffset: 17,
      subject: "What's actually included in your quote",
      preheader: "The full picture – no hidden fees",
      templateKey: 'value_stack'
    },
    {
      id: 'drip_6_personal',
      dayOffset: 24,
      subject: "Quick question about your project",
      preheader: "Just checking in",
      templateKey: 'personal_touch'
    },
    {
      id: 'drip_7_last_chance',
      dayOffset: 30,
      subject: "Should I close your file?",
      preheader: "No hard feelings either way",
      templateKey: 'last_chance'
    },
    {
      id: 'drip_8_10off',
      dayOffset: 35,
      subject: "⏰ 10% off expires in 10 HOURS - final offer",
      preheader: "Last chance before I close your file",
      templateKey: 'last_ditch_10off'
    }
  ]
} as const

export const COMPANY: CompanyInfo = {
  name: 'Bliss Bunk Beds',
  ownerName: 'Jason Tibesar',
  email: 'sales@blissbunkbeds.com',
  phone: '(850) 812-0704',
  website: 'https://blissbunkbeds.com',
  tagline: 'Crafting Dreams, One Bunk at a Time'
} as const

// Statuses eligible for drip campaigns (including retarget for re-engagement)
export const DRIP_ELIGIBLE_STATUSES: string[] = ['new', 'contacted', 'quoted', 'working', 'retarget']

// Statuses that stop drip campaigns
export const DRIP_STOP_STATUSES: string[] = ['won', 'lost', 'unsubscribed', 'booked', 'converted']

log.info('drip_campaign_loaded', {
  emailCount: DRIP_CAMPAIGN.emails.length,
  triggerHours: DRIP_CAMPAIGN.triggerAfterHours
})

export default DRIP_CAMPAIGN
